export enum DeviceConnectionStatusType {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  NeverConnected = 'NEVER_CONNECTED',
}

export interface DeviceConnectionStatus {
  readonly connectionStatus: DeviceConnectionStatusType;
  readonly isConnected: boolean;
  readonly timestamp: string;
  readonly id: string;
}
